import { render, staticRenderFns } from "./tab-bar.vue?vue&type=template&id=3f0553e6&"
import script from "./tab-bar.vue?vue&type=script&lang=js&"
export * from "./tab-bar.vue?vue&type=script&lang=js&"
import style0 from "./tab-bar.vue?vue&type=style&index=0&lang=scss&escoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports